import { useMutation, UseMutationResult, useQuery, UseQueryResult } from '@taxdown/zeno-sama-query';
import UserService from 'Services/user';
import {
  DeleteUserIsAllowed,
  ResponseType,
  NotificationsPreferenceType,
  QueryKeys,
} from 'Types/common';

export const useFetchDeleteUser = (
  logout: () => void
): UseMutationResult<unknown, unknown, unknown, unknown> =>
  useMutation([QueryKeys.DELETE_USER_KEY], UserService.deleteUser, {
    onSuccess: () => logout(),
  });

export const useFetchGetDeleteUser = (): UseMutationResult<DeleteUserIsAllowed> =>
  useMutation(
    [QueryKeys.FETCH_GET_DELETE_USERS],
    (): Promise<DeleteUserIsAllowed> => UserService.getUserDelete()
  );

export const useFetchGetNotificationPreference = (): UseQueryResult<NotificationsPreferenceType> =>
  useQuery([QueryKeys.FETCH_GET_PREFERENCES], UserService.getNotificationsPreference, {
    refetchOnWindowFocus: false,
    select: data => {
      const response = data.data;
      return response.item;
    },
    cacheTime: 0,
  });

export const useFetchPutNotificationPreference = (): UseMutationResult<
  ResponseType<NotificationsPreferenceType>
> =>
  useMutation(
    [QueryKeys.UPDATE_NOTIFICATIONS_PREFERENCE],
    UserService.updateNotificationsPreference,
    {
      cacheTime: 0,
    }
  );
